import React from "react";

import { StateType } from "./chatProvider";

export const CHAT_FLOWS = {
  CONCIERGE: "concierge"
} as const;

export type ChatFlowsType = (typeof CHAT_FLOWS)[keyof typeof CHAT_FLOWS];

export const MESSAGE_ID = {
  CONCIERGE_REQUEST: "conciergeRequest",
  CONCIERGE_REQUEST_RECEIVED: "conciergeRequestReceived",
  LOADING: "loading",
  ERROR: "error"
} as const;

export type MessageIdType = (typeof MESSAGE_ID)[keyof typeof MESSAGE_ID];

export enum Sender {
  Assistant = "assistant",
  System = "system",
  User = "user"
}

export type Message = {
  sender: Sender;
  render: () => React.ReactElement;
  mainText?: String; //this is for adding to open ai's question chain for following up questions
  referencesClassInquiryUid?: string;
};

type FlowConfig = {
  initState: StateType;
};

type ChatFlowConfigsType = { [key in ChatFlowsType]: FlowConfig };
export const CHAT_FLOW_CONFIGS: ChatFlowConfigsType = {
  [CHAT_FLOWS.CONCIERGE]: {
    initState: {
      currentMessageId: MESSAGE_ID.CONCIERGE_REQUEST,
      conversation: []
    }
  }
};
